import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Admin-only: create/grant a course purchase/access.
 * POST /admin/purchases
 * Body: { userId, courseId, status? }
 */
export const createAdminPurchase = async ({ userId, courseId, status = "active", token }) => {
  if (!token) {
    throw new Error("Missing auth token");
  }

  if (!userId || !courseId) {
    throw new Error("Missing userId or courseId");
  }

  const url = `${BASE_URL}/admin/purchases`;
  const payload = { userId, courseId, status };

  const response = await axios.post(url, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json, text/plain, */*",
    },
  });

  return response.data;
};
